import { Typeahead } from 'react-bootstrap-typeahead';
import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DataTables from '../commonComponent/DataTable/DataTables';
import { Cancel, Created, URL_Start } from '../../../constant';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { Spinner } from 'react-bootstrap';
import NoRecordFounds from '../commonComponent/DataTable/NoRecordFounds';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import LoadingButton from '../commonComponent/LoadingButton';
import { CSVLink } from "react-csv";
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { Search, Link } from 'react-feather';
import { useHistory } from 'react-router';

const RequestDebitCreditNote = () => {
    // Handler for autocomplete search
    let ledgerId = useRef();
    const ledgerRef = useRef();
    let fromDate = useRef("2024-01-01");
    let toDate = useRef("2026-01-01");
    // State for autocomplete below Ledger Names
    const history = useHistory();
    const [ledgerSearchOptions, setLedgerSearchOptions] = useState([]);
    const [ledgerSearchLoading, setLedgerSearchLoading] = useState(false);
    const [ledgerSearchNoData, setLedgerSearchNoData] = useState(false);
    const [selectedLedgerSearchId, setSelectedLedgerSearchId] = useState('U');
    const [reportSelection, setReportSelection] = useState("0");
    const [isLoading, setIsLoading] = useState(false);
    const [sapStatesList, setSAPStatesList] = useState([]);
    const [sapRegionsList, setSAPRegionsList] = useState([]);
    const [ledgerNamesList, setLedgerNamesList] = useState([]);
    const [noteTypesList, setNoteTypesList] = useState([]);
    const [ledgerType, setLedgerType] = useState("1");
    const [noteTypeLabel, setNoteTypeLabel] = useState("Debit Note");
    const [tableData, setTableData] = useState([]);
    const [crntPageNO, setCrntPageNO] = useState(0);
    const [isLedgerExist, setIsLedgerExist] = useState(false);
    const [testsModal, setTestsModal] = useState();
    const openModal = () => { setTestsModal(!testsModal); };
    const [invalidfiletype, setInvalidFileType] = useState(false)
    const [modal, setModal] = useState();
    const [errorModal, setErrorModal] = useState();
    const errorHandler = () => { setModal(true); setErrorModal(true); }
    const [isSaving, setIsSaving] = useState(false);
    const [csvLedger, setCSVLedger] = useState([]);
    const [downloadvisible, setDownloadVisible] = useState(false);
    const [isButton, setIsButton] = useState(false);
    const [lid, setLID] = useState("0");
    const [centreList, setCentreList] = useState([]);
    const [defaultDate, setDefaultDate] = useState("");
    const [selectionType, setSelectionType] = useState('1'); // 1 = Invoice No, 2 = ItemList
    const paginationOptions = { sizePerPage: 50, showTotal: false, firstPageText: 'First', prePageText: 'Back', nextPageText: 'Next', lastPageText: 'Last', onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); } };

    const [dcDetailsOptions, setDcDetailsOptions] = useState([]); // options for details dropdown
    const [selectedDcDetail, setSelectedDcDetail] = useState('0');
    const [noteTypeOption, setNoteTypeOption] = useState('1'); // 1 Debit, 2 Credit, 3 Discount
    const [narration, setNarration] = useState("");
    let partialAmount = useRef("");
    const [amount, setAmount] = useState("");
    const [centres, setCentres] = useState([]);
    const [selectedCentreId, setSelectedCentreId] = useState("0");
    const [categoryId, setCategoryId] = useState("0"); // NEW: Category state

    // State for Item No, Amount, and Total Amount
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
            <div>
                <span>{crntPageNO + rowIndex + 1}</span>
            </div>
        </React.Fragment>
    }
    const columns = [
        { dataField: '#', text: '#', editable: false, formatter: idFormatter },
        // Hide InvoiceNo column when selectionType === "2"
        ...(selectionType === "1"
            ? [{
                dataField: 'InvoiceNo', text: 'Invoice No', editable: false, formatter: (cell, row) => {
                    return (
                        <span
                            onClick={() => Printreceipt(row.VisitingID || row.VistingID)}
                            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                        >
                            {cell}
                        </span>
                    );
                }
            }]
            : []),
        { dataField: 'ItemCode', text: 'Item Code', editable: false },
        { dataField: 'Item', text: 'Item', editable: false },
        { dataField: 'ItemType', text: 'ItemType', editable: false },
        ...(selectionType === "1"
            ? [{ dataField: 'ItemRate', text: 'Rate', editable: false }]
            : []),
        { dataField: 'Refunded', text: 'Refunded', editable: false },
        {
            dataField: 'Qty',
            text: 'Qty',
            headerStyle: { width: '80px' },
            style: { width: '80px', height: '65px' },
            editable: (cell, row, rowIndex, colIndex) =>
                selectionType === "2" && (row.Refunded === false || row.Refunded === "false"),
            editor: {
                type: Type.NUMBER
            },
            validator: (newValue, row) => {
                if (selectionType === "2") {
                    if (!/^\d+$/.test(newValue) || parseInt(newValue) < 1) {
                        SweetAlert.fire("Error", "Qty must be a positive integer and at least 1", "error");
                        return { valid: false };
                    }
                }
                return true;
            }
        },
        {
            dataField: 'Amount',
            text: 'Amount',
            headerStyle: { width: '100px' },
            style: { width: '100px', height: '65px' },
            editable: (cell, row, rowIndex, colIndex) => row.Refunded === false || row.Refunded === "false",
            editor: {
                type: Type.NUMBER,
                style: { width: '80px' }
            },
            validator: (newValue, row) => {
                if (newValue !== undefined && newValue !== null && newValue !== "") {
                    if (!/^\d*\.?\d+$/.test(newValue) || parseFloat(newValue) <= 0) {
                        SweetAlert.fire("Error", "Amount must be a positive number", "error");
                        return { valid: false };
                    }
                    if (parseFloat(newValue) > parseFloat(row.ItemRate)) {
                        SweetAlert.fire("Error", "Amount cannot be greater than Rate", "error");
                        row.Amount = newValue;
                        return { valid: false };
                    }
                }
                return true;
            }
        },
        {
            dataField: 'TotalAmount',
            text: 'TotalAmount',
            editable: false,
            formatter: (cell, row) => {
                const qty = (parseFloat(row.Qty) || 0).toFixed(2);
                const amount = (parseFloat(row.Amount) || 0).toFixed(2);
                return qty * amount;
            }
        },
        {
            dataField: 'LinkInvoiceNo',
            text: 'Link Invoice',
            editable: false,
            formatter: (cell) => {
                if (!cell) return null;
                return (
                    <span style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Link size={28} style={{ marginRight: '10px', color: '#003366' }} />
                        <span style={{ fontSize: '11px' }}>{cell}</span>
                    </span>
                );
            }
        }
    ];

    useEffect(() => {
        const today = new Date();
        const date = today.setDate(today.getDate());
        const defaultValue = new Date(date).toISOString().split('T')[0]
        setDefaultDate(defaultValue);
        GetLedgerNames("1", "0");
        setTableData([]);
        setAvailableDetailsOptions([]);
        setAddedDetails([]);
        setDcDetailsOptions([]);
        setSelectedDcDetail('0');
        setIsLedgerExist(false);
        setCategoryId("0");
    }, []);

    const handleSearch = async (val) => {
        if (ledgerId.current != "0" && fromDate.current.value != "" && toDate.current.value != "") {
            try {
                const from = new Date(fromDate.current.value);
                const to = new Date(toDate.current.value);
                const threeMonthsBack = new Date(to);
                threeMonthsBack.setMonth(threeMonthsBack.getMonth() - 12);
                if (from < threeMonthsBack) {
                    SweetAlert.fire("The date range between From Date and To Date cannot exceed 12 months.");
                    return false;
                }
            } catch (e) { /* ignore parse issues */ }
            var stDate = selectionType;
            if (val === '1' || val === '2') {
                stDate = val;
            }
            setIsLedgerExist(true);
            GetInvoiceNoDebitCreditDetails(stDate, fromDate.current.value, toDate.current.value, ledgerId.current, ledgerType);
            setTableData([]);
            setAvailableDetailsOptions([]);
            setAddedDetails([]);
        }
    }

    const handleLedgerSearch = async (query) => {
        setLedgerSearchLoading(true);
        setLedgerSearchNoData(false);
        try {
            let url = `${URL_Start}accounts/GetLedgerdetails/${query}`;
            const response = await axios.get(url);
            const data = response.data;
            if (data.Success && data.Data && data.Data.length > 0) {
                setLedgerSearchOptions(data.Data.map(d => ({ Id: d.Id, Value: d.Value })));
                setLedgerSearchNoData(false);
            } else {
                setLedgerSearchOptions([]);
                setLedgerSearchNoData(true);
            }
        } catch (error) {
            setLedgerSearchOptions([]);
            setLedgerSearchNoData(true);
        }
        setLedgerSearchLoading(false);
    };

    const GetInvoiceNoDebitCreditDetails = async (selType, fromVal, toVal, ledgerIdVal, ledgerType) => {
        try {
            let url = URL_Start + 'accounts/GetInvoiceNo_DebitCreditDetails/' + selType + '/' + fromVal + '/' + toVal + '/' + ledgerIdVal + '/' + ledgerType;
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data && data.Data.length > 0) {
                        setDcDetailsOptions(data.Data.map((d) => (<option key={d.Id} value={d.Id}>{d.Value}</option>)));
                        setSelectedDcDetail('0');
                    } else {
                        setDcDetailsOptions([]);
                        setSelectedDcDetail('0');
                    }
                } else {
                    setDcDetailsOptions([]);
                    setSelectedDcDetail('0');
                }
            }).catch(function (error) { setDcDetailsOptions([]); setSelectedDcDetail('0'); });
        } catch (error) { setDcDetailsOptions([]); setSelectedDcDetail('0'); }
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const formik = useFormik({
        initialValues: { noteType: '1', noteReason: '', noteAmount: '', noteNarration: '', noteReceipt: '' },
        validationSchema: Yup.object({
            noteAmount: Yup.number().min(1, 'Amount must be than zero').typeError('Amount must be numeric only').required('Amount is required'),
            noteReason: Yup.string().required('Reason is required')
        }),
        onSubmit: values => {
            setModal(false);
            setErrorModal(false);
        }
    });

    const APIError = async (ErrorCode, ErrorMsg) => {
        if (ErrorCode === "-1") { SweetAlert.fire({ title: "Data unavailable", text: "No record found", icon: "error" }) }
        else if (ErrorCode === "-2") { SweetAlert.fire({ title: "API Server Error", text: ErrorMsg, icon: "error" }); }
        else if (ErrorCode === "-3") { SweetAlert.fire({ title: "Runtime Exception", text: "Some error occured! Please try after sometime.", icon: "error" }) }
        else if (ErrorCode === "-4") { SweetAlert.fire({ title: "Wrong Credentials", text: "Please enter correct credentials", icon: "error" }) }
        else if (ErrorCode === "-5") { SweetAlert.fire({ title: "Oops", text: "Data could not be saved, Please try again later", icon: "error" }) }
        else if (ErrorCode === "-6") { SweetAlert.fire({ title: "Failed", text: "Check DB Logs", icon: "error" }) }
        else if (ErrorCode === "-7") { SweetAlert.fire({ title: "Duplicate", text: "Template already exists", icon: "error" }) }
        else if (ErrorCode === "-8") { SweetAlert.fire({ title: "Data unavailable", text: "No record found to import", icon: "error" }) }
        else if (ErrorCode === "-9") { SweetAlert.fire({ title: "LDAP authentication failed", text: ErrorMsg, icon: "error" }) }
        else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }) }
    }

    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400") { SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" }) }
        else if (ErrorCode == "401") { SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" }) }
        else if (ErrorCode == "403") { SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" }) }
        else if (ErrorCode == "404") { SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" }) }
        else if (ErrorCode == "500") { SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" }) }
        else if (ErrorCode == "503") { SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" }) }
    }

    const upRateManage = (newValue, rowData, column) => {
        setTableData(prev => {
            const updated = prev.map(row => {
                if (row.PatientItemDetailsId === rowData.PatientItemDetailsId) {
                    let updatedRow = { ...row };
                    if (column.dataField === "Qty") {
                        updatedRow.Qty = newValue;
                    }
                    if (column.dataField === "Amount") {
                        updatedRow.Amount = newValue;
                    }
                    updatedRow.TotalAmount = (parseInt(updatedRow.Qty) || 0) * (parseInt(updatedRow.Amount) || 0);
                    return updatedRow;
                }
                return row;
            });

            const total = updated.reduce((sum, r) => {
                const qty = (parseFloat(r.Qty) || 0).toFixed(2);
                const amt = (parseFloat(r.Amount) || 0).toFixed(2);
                return sum + (qty * amt);
            }, 0);

            setAmount(total);
            partialAmount.current = total;

            return updated;
        });
    };

    const Printreceipt = (vId) => {
        if (vId !== "0") {
            localStorage.removeItem('vId');
            localStorage.setItem('vId', vId);
            window.open(`${process.env.PUBLIC_URL}/admin/receipt`, '_blank');
        }
    }

    // Add this state to track available options and selected details
    const [availableDetailsOptions, setAvailableDetailsOptions] = useState([]);
    const [addedDetails, setAddedDetails] = useState([]);
    // Add state to track selected detail for Typeahead
    const [selectedDetail, setSelectedDetail] = useState([]);

    // Update availableDetailsOptions when dcDetailsOptions changes
    useEffect(() => {
        setAvailableDetailsOptions(
            dcDetailsOptions.length > 0
                ? dcDetailsOptions.map(opt => ({ Id: opt.props.value, Value: opt.props.children }))
                : []
        );
    }, [dcDetailsOptions]);

    // Modified handleDetailSelect for single selection and option removal
    const handleDetailSelect = async (selected) => {
        if (selected.length > 0) {
            if (selectionType === "1") {
                setTableData([]);
            }
            const sel = selected[0];
            try {
                const url = `${URL_Start}accounts/GetInvoiceItem_itemDetails/${sel.Id}`;
                setAmount("");
                const response = await axios.get(url);
                const data = response.data;
                if (data && data.Data) {
                    setTableData(prev => [
                        ...prev,
                        ...data.Data.map(row => ({ ...row, DetailId: sel.Id }))
                    ]);
                    setAddedDetails(prev => [...prev, sel.Id]);
                    if (selectionType === "2") {
                        setAvailableDetailsOptions(prev => prev.filter(opt => opt.Id !== sel.Id));
                    }
                }
            } catch (error) {
                // Optionally handle error
            }
        }
    };

    const handleRadioChange = async (e) => {
        ledgerId.current = "";
        ledgerRef.current.clear();
        setLID("");
        setLedgerNamesList([]);
        setTableData([]);
        setNarration("");
        setAmount("");
        setReportSelection("0");
        setLedgerType(e.target.value);
        setCategoryId("0"); // NEW: Reset category on ledger type change
        if (e.target.value === "2" && noteTypeOption === "3") {
            setNoteTypeOption("1");
        }
        setLID("0");
        setIsLedgerExist(false);

        if (e.target.value === "1") { GetLedgerNames("1", "0"); } else {
            GetLedgerNames("2", "0");
        }
    }

    const GetLedgerNames = async (lType, rId) => {
        setIsButton(true);
        try {
            let url = URL_Start + 'accounts/getledgersname/' + lType + '/' + rId
            await axios.get(url).then((response) => {
                const data = response.data;
                setIsButton(false);
                if (data.Success) {
                    setLedgerNamesList(data.Data);
                }
            }).catch(function (error) { setIsButton(false); });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }

    const GetCentresMap = async () => {
        try {
            const url = `${URL_Start}/accounts/GetCentreMappingList/${lid}`;
            const response = await axios.get(url);
            if (response.data?.Success) {
                setCentres(response.data.Data);
            } else {
                setCentres([]);
            }
        } catch (error) {
            console.error("Centre API error", error);
            setCentres([]);
        }
    };

    const autoBindSearch = async (lId) => {
        ledgerId.current = lId;
        setIsLedgerExist(false);
        setNarration("");
        if (lId > "0" && fromDate.current.value !== "" && toDate.current.value !== "") {
            handleSearch('null');
        }
    }

    const handleRadioInvItemChange = async (e) => {
        var Value = e.target.value;
        setSelectionType(Value);
        if (Value === "2" && noteTypeOption === "3") {
            setNoteTypeOption("1");
        }
        setNarration("");
        setAmount("");
        partialAmount.current = "";
        setReportSelection("0");
        setCategoryId("0"); // NEW: Reset category on selection type change
        setTableData(prev =>
            prev.map(row => ({
                ...row,
                Amount: (row.Refunded === false || row.Refunded === "false") ? "" : row.Amount,
                TotalAmount: 0
            }))
        );
        handleSearch(Value);

        if (Value === "2" && ledgerType === "1") {
            GetCentresMap();
        }
    }

    const handleSubmitDRCRNote = async (skipAmountCheck = false) => {
        // NEW: Category validation
        if (categoryId === "0") {
            SweetAlert.fire("Category selection is mandatory");
            return;
        }

        if (selectionType === "2" && (reportSelection === "0" || reportSelection === "" || reportSelection === null)) {
            SweetAlert.fire("Report selection is mandatory");
            return;
        }

        if (ledgerType === "1" && selectionType === "2" && (selectedCentreId === "0" || selectedCentreId === "" || selectedCentreId === null)) {
            SweetAlert.fire("Centre selection is mandatory");
            return;
        }

        if (narration.trim() === "") {
            SweetAlert.fire("Please enter narration.");
            return;
        }

        // If not skipping, check that all Amount fields are filled (not blank or zero)
        if (!skipAmountCheck) {
            const invalidRow = tableData.find(row =>
                (row.Refunded === false || row.Refunded === "false") && (selectionType === "2") &&
                (row.Amount === undefined || row.Amount === null || row.Amount === "" || parseInt(row.Amount) <= 0)
            );
            if (invalidRow) {
                SweetAlert.fire("Amount is required and must be greater than zero for item rows.");
                return;
            }

            const invalidInvoiceRow = tableData.find(row =>
                (row.Refunded === false || row.Refunded === "false") && (selectionType === "1") &&
                (parseInt(row.Amount) > 0)
            );
            if (!invalidInvoiceRow && selectionType === "1" && skipAmountCheck === false) {
                SweetAlert.fire("An amount greater than zero is required in at least one invoice row.");
                return;
            }

            const invalidInvoiceRowValue = tableData.find(row =>
                (row.Refunded === false || row.Refunded === "false") && (selectionType === "1") &&
                (parseInt(row.Amount) > 0) && (parseFloat(row.ItemRate) >= parseFloat(row.Amount))
            );
            if (!invalidInvoiceRowValue && selectionType === "1" && skipAmountCheck === false) {
                SweetAlert.fire("An amount less than or equal to rate is required.");
                return;
            }
        }

        var vv = getTotalAmountSum();
        var vv1 = getFullDebitCreditTotal();

        try {
            const payload = {
                ledgerType: ledgerType,
                LedgerId: lid,
                categoryid: categoryId, // NEW: Category ID in payload
                FromDate: fromDate.current.value,
                ToDate: toDate.current.value,
                NoteType: noteTypeOption,
                NoteReason: narration,
                CreatedBy: localStorage.LoggedInUser,
                ReceiptName: formik.values.noteReceipt,
                InvoiceNo: tableData.length > 0 ? tableData[0].InvoiceNo : "",
                InvoiceType: selectionType === "1" ? "Invoice" : "ItemList",
                FullPartail: (skipAmountCheck === true || vv === vv1) ? "Full" : "Partial",
                ReportSelection: selectionType === "1" ? "1" : reportSelection,
                CentreID: selectedCentreId === null || selectedCentreId === undefined || selectedCentreId === "0" ? "0" : selectedCentreId,
                TableData: tableData
            };
            const url = `${URL_Start}accounts/SetRequestedDRCRNote`;
            const response = await axios.post(url, payload);
            if (response.data && response.data.Success) {
                SweetAlert.fire({
                    title: "Success",
                    text: (noteTypeOption === "1" ? "Debit" : noteTypeOption === "3" ? "Discount" : "Credit") + " Note submitted successfully!",
                    icon: "success"
                }).then(() => {
                    handleOpenDebitCreditNote();
                });
            }
            else if (response.data.ErrorList[0].errorCode === "-2001") {
                SweetAlert.fire("Error", "Debit Credit note already submitted.", "error");
            } else {
                SweetAlert.fire("Error", response.data.Message || "Failed to submit.", "error");
            }
        } catch (error) {
            SweetAlert.fire("Error", "API call failed.", "error");
        }
    };

    // Helper to calculate total sum of TotalAmount column
    const getTotalAmountSum = () => {
        return tableData.reduce((sum, row) => {
            const qty = parseInt(row.Qty) || 0;
            const amount = parseInt(row.Amount) || 0;
            return sum + (qty * amount);
        }, 0);
    };

    const getFullDebitCreditTotal = () => {
        return tableData
            .filter(row => row.Refunded === false || row.Refunded === "false")
            .reduce((sum, row) => sum + ((parseFloat(row.Qty) || 0) * (parseFloat(row.ItemRate) || 0)), 0);
    };

    const handleOpenDebitCreditNote = async () => {
        history.push({ pathname: `${process.env.PUBLIC_URL}/accounts/ApproveDebitCreditNote` });
    };

    const handleLedgerChange = (selected) => {
        if (JSON.stringify(selected) === "[]") {
            setLID("0");
        } else {
            setLID(selected[0].Id);
            setTimeout(() => {
                autoBindSearch(selected[0].Id);
            }, 0);
        }
    };

    const handleChangeTxtAmount = (e) => {
        const val = e.target.value;
        const totval = getFullDebitCreditTotal();

        if (isNaN(val) || parseFloat(val) < 0 || (parseFloat(val) > totval)) {
            SweetAlert.fire("Please enter a valid amount between 1 and " + totval.toFixed(2));
            return;
        }
        setAmount(val);
        partialAmount.current = val;

        setTableData(prev =>
            prev.map(row => ({
                ...row,
                Amount: row.Refunded === "false" ? (((row.ItemRate / totval) * val).toFixed(2) === "0.00" ? "" : ((row.ItemRate / totval) * val).toFixed(2)) : row.Amount,
                TotalAmount: 0
            }))
        );
    };

    const UploadImages = async (e, folderName) => {
        const extension = e.target.files[0].name.split(".");
        if (extension[1].toLowerCase() === "pdf" || extension[1].toLowerCase() === "jpg" || extension[1].toLowerCase() === "jpeg" ||
            extension[1].toLowerCase() === "png" || extension[1].toLowerCase() === "gif" || extension[1].toLowerCase() === "svg") {
            setInvalidFileType(false);
            var base64 = await toBase64(e.target.files[0]);
            var base64img = base64.split("base64,");
            const formData = new FormData();
            formData.append('Image', base64img[1]);
            formData.append('FolderName', folderName);
            const randomImageId = Math.random();
            var imgName = randomImageId + folderName + "." + extension[extension.length - 1];
            formData.append('ImageName', imgName);
            let url = URL_Start + 'master/UploadImage/'
            await axios.post(url, formData, {
                headers: { "Content-type": "multipart/form-data" },
            }).then((response) => {
                const data = response.data;
                if (data.Success) { formik.values.noteReceipt = imgName; }
                else { SweetAlert.fire({ title: "Upload failed", text: "Unable to upload document due to " + data.Data + ".Please retry again", icon: "error" }) }
            }).catch(function (error) { if (error.response) { } });
        }
        else { SweetAlert.fire("Invalid file type! You can upload only image/pdf only, please reupload valid file only."); setInvalidFileType(true); return false; }
    }

    return (
        <React.Fragment>
            <Breadcrumb title="Debit Credit Note" parent="Accounts" />
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form.Row>
                                    <Col md={3}>
                                        <Form.Label className='mb-4'><b>Ledger Type</b></Form.Label>
                                        <Form.Group className='animate-chk m-checkbox-inline center__type mt-15'>
                                            <Form.Label for="centreType1">
                                                <input class="radio_animated" type="radio" id='centreType1' name="rdoo-ani" defaultChecked onChange={handleRadioChange} value='1' />Own
                                            </Form.Label>
                                            <Form.Label for="centreType2">
                                                <input class="radio_animated" type="radio" id='centreType2' name="rdoo-ani" onChange={handleRadioChange} value='2' />Third Party
                                            </Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col md={9} className='text-right' >
                                        <Form.Group >
                                            <Button variant='primary' type='submit' className="mr-2" onClick={() => handleOpenDebitCreditNote()}>Back</Button>
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col md={4}>
                                        <Form.Group className='thirdParty'>
                                            <Form.Label>Ledger Names</Form.Label>
                                            {isButton ? <Spinner animation="border" size='sm' /> : null}
                                            <Typeahead
                                                id="ledger-names"
                                                labelKey="Value"
                                                options={ledgerNamesList}
                                                placeholder="---Select---"
                                                ref={ledgerRef}
                                                onChange={handleLedgerChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                    </Col>
                                    <Col md={2}>
                                    </Col>
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        {isLedgerExist ? <Card>
                            <Card.Header className='pb-0'>
                                <Card.Title>Debit Credit Note Details</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form>
                                    <Row>
                                        {(ledgerType !== '3') && (
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Select Type</Form.Label>
                                                    <div className='animate-chk m-checkbox-inline center__type mt-15'>
                                                        <Form.Label htmlFor="selType1">
                                                            <input className="radio_animated" type="radio" id='selType1' name="selectionType"
                                                                checked={selectionType === "1"}
                                                                onChange={handleRadioInvItemChange}
                                                                Value="1"
                                                            /> Invoice No
                                                        </Form.Label>
                                                        <Form.Label htmlFor="selType2">
                                                            <input className="radio_animated" type="radio" id='selType2' name="selectionType"
                                                                checked={selectionType === "2"}
                                                                onChange={handleRadioInvItemChange}
                                                                Value="2"
                                                            /> ItemList
                                                        </Form.Label>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        <Col md={8} className='text-right'>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Select {selectionType === "1" ? "Invoice" : "Item"}</Form.Label>
                                                <Typeahead
                                                    id="select-detail-typeahead"
                                                    labelKey="Value"
                                                    options={availableDetailsOptions}
                                                    placeholder="Type to search..."
                                                    onChange={handleDetailSelect}
                                                    selected={selectedDetail}
                                                    renderMenuItemChildren={(option) => (
                                                        <span>{option.Value}</span>
                                                    )}
                                                />
                                            </Form.Group>
                                        </Col>
                                        {/* NEW: Category Dropdown */}
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Category</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    value={categoryId}
                                                    onChange={(e) => setCategoryId(e.target.value)}
                                                >
                                                    <option value="0">--- Select Category ---</option>
                                                    <option value="1">Purchase</option>
                                                    <option value="2">Sale</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            {/* Narration Text Box */}
                                            <Form.Group>
                                                <Form.Label>Narration</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter narration"
                                                    value={narration}
                                                    onChange={e => setNarration(e.target.value)}
                                                    maxLength={200}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Note Type</Form.Label>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div
                                                        className='animate-chk center__type mt-15'
                                                        style={{ display: 'flex', flexDirection: 'column' }}
                                                    >
                                                        <Form.Label htmlFor="nt1" style={{ display: 'block', marginBottom: '8px' }}>
                                                            <input className="radio_animated" type="radio" id='nt1' name="noteTypeOpt" checked={noteTypeOption === '1'} onChange={() => setNoteTypeOption('1')} />
                                                            Debit Note
                                                        </Form.Label>
                                                        <Form.Label htmlFor="nt2" style={{ display: 'block', marginBottom: '8px' }}>
                                                            <input className="radio_animated" type="radio" id='nt2' name="noteTypeOpt" checked={noteTypeOption === '2'} onChange={() => setNoteTypeOption('2')} />
                                                            Credit Note
                                                        </Form.Label>
                                                        {selectionType === "1" && ledgerType !== "2" && (
                                                            <Form.Label htmlFor="nt3" style={{ display: 'block', marginBottom: '8px' }}>
                                                                <input className="radio_animated" type="radio" id='nt3' name="noteTypeOpt" checked={noteTypeOption === '3'} onChange={() => setNoteTypeOption('3')} />
                                                                Discount Note
                                                            </Form.Label>
                                                        )}
                                                    </div>
                                                    <Form.Label style={{ color: 'red', fontWeight: 'bold', marginTop: 12, fontSize: 14 }}>
                                                        {noteTypeOption === '3'
                                                            ? 'Discount will decrease balance.'
                                                            : ledgerType === '1'
                                                                ? (noteTypeOption === '1' ? 'Debit will increase balance.' : 'Credit will decrease balance.')
                                                                : (noteTypeOption === '1' ? 'Debit will decrease balance.' : 'Credit will increase balance.')}
                                                    </Form.Label>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>{noteTypeLabel} Receipt(image/pdf only)</Form.Label>
                                                <div><input type="file" onChange={(e) => UploadImages(e, "DebitCreditNote")} accept="image/*,.pdf" /></div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            {selectionType === "2" && (
                                                <Form.Group>
                                                    <Form.Label>Report Display</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        value={reportSelection}
                                                        onChange={(e) => setReportSelection(e.target.value)}
                                                    >
                                                        <option value="0">---Select---</option>
                                                        <option value="1">Show in Report</option>
                                                        <option value="2">Do not show in Report</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            )}
                                        </Col>
                                        <Col md={4}>
                                            {selectionType === "2" && ledgerType !== '2' && (
                                                <Form.Group>
                                                    <Form.Label>Select Centre</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        value={selectedCentreId}
                                                        onChange={(e) => setSelectedCentreId(e.target.value)}
                                                    >
                                                        <option value="0">--- Select Centre ---</option>
                                                        {centres.map((c) => (
                                                            <option key={c.Id} value={c.Id}>
                                                                {c.Value}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            )}
                                        </Col>
                                        <Col md={4} className='text-right'></Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} className='text-center __center__buttonsec'>
                                            <div className="table-responsive mt15">
                                                <BootstrapTable
                                                    keyField='PatientItemDetailsId'
                                                    data={tableData}
                                                    columns={columns}
                                                    bootstrap4
                                                    headerWrapperClasses="thead-light"
                                                    bordered={false}
                                                    noDataIndication={<NoRecordFounds />}
                                                    cellEdit={cellEditFactory({
                                                        mode: 'click',
                                                        blurToSave: true,
                                                        afterSaveCell: (oldValue, newValue, rowData, column) => { upRateManage(newValue, rowData, column) },
                                                    })}
                                                >
                                                </BootstrapTable>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div style={{ height: "20px" }} />
                                    <Row>
                                        <Col md={10} className='text-center __center__buttonsec'></Col>
                                        <Col md={2} className='text-center __center__buttonsec'>
                                            <Form.Control
                                                type="text"
                                                placeholder="Amount"
                                                onChange={handleChangeTxtAmount}
                                                value={amount}
                                                readOnly={true}
                                            />
                                        </Col>
                                    </Row>
                                    <div style={{ height: "40px" }} />
                                    <Row>
                                        <Col md={2} className='left__align__text'></Col>
                                        <Col md={1} className='right__align__text'>
                                            {tableData.length > 0 && (getFullDebitCreditTotal() > 0 || selectionType === "2") && (
                                                <>
                                                    <Button
                                                        variant="danger"
                                                        onClick={() => {
                                                            SweetAlert.fire({
                                                                title: "Are you sure?",
                                                                text: "Would you like to submit this " + (noteTypeOption === "1" ? "debit" : noteTypeOption === "3" ? "discount" : "credit") + " note for an amount of " + amount + "?",
                                                                icon: "warning",
                                                                showCancelButton: true,
                                                                confirmButtonColor: "#3085d6",
                                                                cancelButtonColor: "#d33",
                                                                confirmButtonText: "Yes, submit it!",
                                                            }).then((result) => {
                                                                if (result.isConfirmed) {
                                                                    handleSubmitDRCRNote(false);
                                                                }
                                                            });
                                                        }}
                                                        className="mr-2"
                                                    >
                                                        {getTotalAmountSum() > 0
                                                            ? `Submit`
                                                            : "Submit"}
                                                    </Button>
                                                </>
                                            )}
                                        </Col>
                                        <Col md={3} className='left__align__text'>
                                            <>
                                                {selectionType === "1" && noteTypeOption !== "3" && getFullDebitCreditTotal() > 0 && (
                                                    <Button variant="link" onClick={() => {
                                                        SweetAlert.fire({
                                                            title: "Are you sure?",
                                                            text: "Would you like to submit full " + (noteTypeOption === "1" ? "Debit" : "Credit") + " note for an amount of " + getFullDebitCreditTotal() + "?",
                                                            icon: "warning",
                                                            showCancelButton: true,
                                                            confirmButtonColor: "#3085d6",
                                                            cancelButtonColor: "#d33",
                                                            confirmButtonText: "Yes, submit it!",
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                handleSubmitDRCRNote(true);
                                                            }
                                                        });
                                                    }}>
                                                        Full Debit/Credit Note ({getFullDebitCreditTotal()})
                                                    </Button>
                                                )}
                                            </>
                                        </Col>
                                        <Col md={5} className='left__align__text'></Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card> : null}
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
}
export default RequestDebitCreditNote;